<template>
  <v-app
    class="ma-0" :style="{ background: $vuetify.theme.themes.light.background }"
    style="min-height: 100% !important;"
  >
    <component :is="layout" :headerlogo="headerLogoUrl" @themeChanged="themeChanged"></component>

    <confirmation-menu :visible="menuShow" :pos-x="menuPosX" :pos-y="menuPosY" @answer="confirmationAccept($event)">
    </confirmation-menu>

    <v-row align="center" justify="center">
      <v-dialog v-model="toastShowed " max-width="30vw">
        <v-card id="toast" class="pa-6 ">
          <v-btn icon small class="close-btn" @click="toastShowed = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-card-text style="text-align: center">
            <v-container>
              <v-row justify="center">
                <v-icon x-large class="display-3 mb-2" :color="toastColor">{{ toastIcon }}</v-icon>
              </v-row>
              <v-row justify="center" class="text-h6 text-wrap" :class="toastColor + '--text'">
                {{ toastMessage }}
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog v-model="showInactiveModal" max-width="400">
        <v-card class="pa-6">
          <v-card-title>
            {{ $t('inactiveUser.title') }}
          </v-card-title>
          <v-card-text>
            {{ $t('inactiveUser.explainer') }} {{ timerCount }}
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-idle :reminders="reminder" :duration="logoutTime" class="d-none" :events="['mousemove', 'keypress']" @idle="onidle" @remind="onremind" @refresh="onrefresh">
    </v-idle>
    <v-snackbar v-model="noServiceVisible" :timeout="-1" color="error" top>
      {{ $t('connectionLost.noServiceMessage') }}
    </v-snackbar>
    <v-snackbar v-model="reconnectVisible" color="success" top>
      {{ $t('connectionLost.reconnectMessage') }}
    </v-snackbar>
  </v-app>
</template>

<script>
import ConfirmationMenu from '@/components/ConfirmationMenu.vue'
import Vidle from 'v-idle'
import createDynamicTheme from './common/theme'
import eventBus from './event-bus'
import eventTypes from './eventTypes.js'
import LayoutBlank from './layout/Blank.vue'
import LayoutContent from './layout/Content.vue'
import server from './services/api/server.js'
export default {
  components: {
    LayoutBlank,
    LayoutContent,
    ConfirmationMenu,
    Vidle
  },

  data() {
    return {
      toastShowed: false,
      toastIcon: null,
      toastColor: null,
      toastMessage: null,
      toastDescription: null,
      confirmationDialogShowed: false,
      confirmationTitle: null,
      confirmationText: null,

      // confmenu
      menuPosX: null,
      menuPosY: null,
      menuTitle: null,
      menuShow: false,

      showInactiveModal: false,
      timerCount: 0,
      logoutTime: 300,
      reminder: [],

      // heartbeat from server connection check
      noServiceVisible: false,
      reconnectVisible: false,
      timerId: 0,

      headerLogo: null

    }
  },

  computed: {
    layout() {
      if (!this.$route.name) return null
      if (this.$route.meta.layout === 'blank') return 'layout-blank'

      return 'layout-content'
    },
    headerLogoUrl() {
      return this.headerLogo
    }
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
          }, 1000)
        } else {
          this.showInactiveModal = false
        }
      },
      immediate: true // This ensures the watcher is triggered upon creation
    }
  },

  async mounted() {
    eventBus.$on('showToast', ({ icon, type, message }) => {
      this.toastShowed = true
      this.toastIcon = icon
      this.toastColor = type
      this.toastMessage = message
    })

    eventBus.$on('showConfirmationMenu', (opts) => {
      this.menuShow = true
      this.menuTitle = opts.title
      this.menuPosX = opts.posX
      this.menuPosY = opts.posY
    })

    this.$store.commit('setRemoteConfig', await server.getRemoteConfig())
    this.logoutTime = +this.$store.state.remoteConfig.logoutTimeSeconds
    this.reminder = [parseInt(this.$store.state.remoteConfig.logoutReminderSeconds)]

    eventBus.$on(eventTypes.HEARTBEAT, this.onHeartbeat)
    eventBus.$on(eventTypes.CONNECTION_LOST, (err) => {
      if ((this.$store.state.currentUser !== null) && (this.$store.state.currentUser.status !== 'SUSPENDED') && (this.$store.state.currentUser.roles?.length > 0) && (this.$store.state.currentUser.roles[0].length > 0)) {
        this.noServiceVisible = true
      }
      console.error(err)
    })
    eventBus.$on(eventTypes.CONNECTION_ESTABLISHED, this.onReconnect)

    eventBus.$on(eventTypes.LOGOUT, this.onLogout)

    // console.log('app mounted this.$store.state.currentTheme', this.$store.state.currentTheme)
    if (this.$store.state.currentTheme) {
      this.setThemeImpl(this.$store.state.currentTheme, false)
    } else {
      // console.log('theme is empty')
    }
  },

  methods: {
    themeChanged(themename) {
      this.setTheme(themename)
    },
    startHeartbeatTimer() {
      this.timerId = setTimeout(() => {
        this.noServiceVisible = true
        this.resetHeartbeatTimer()
      }, 31000) // 31 seconds
    },
    resetHeartbeatTimer() {
      clearTimeout(this.timerId)
      this.startHeartbeatTimer()
    },
    async onLogout() {
      await this.$auth.logout()
    },
    onHeartbeat() {
      if (this.noServiceVisible) {
        this.noServiceVisible = false
      }
      this.resetHeartbeatTimer()
    },

    onReconnect() {
      if (this.noServiceVisible) {
        this.noServiceVisible = false
        this.reconnectVisible = true
        clearTimeout(this.timerId)
      }
    },
    onrefresh(event) {
      if (this.showInactiveModal) {
        this.showInactiveModal = false
        this.timerCount = 0
      }
    },
    confirmationAccept(value) {
      eventBus.$emit('confirmationAccept', { value })
      this.menuShow = false
    },
    async onidle() {
      if (this.$store.state.currentUser) {
        this.showInactiveModal = false
        this.$router.push('/logout')
        const rsspUrl = this.$store.state.remoteConfig && this.$store.state.remoteConfig.rsspPublicUrl
        if ((rsspUrl !== undefined) && (rsspUrl.length > 0)) {
          const logouturl = rsspUrl + 'logout'
          window.location.href = logouturl
        }
      } else {
      }
    },
    onremind(time) {
      if (this.$store.state.currentUser) {
        this.showInactiveModal = true
        this.timerCount = time
      } else {
      }
    },
    setTheme(themename) {
      if (themename === 'i4p') {
        this.setThemeImpl(this.$vuetify.theme.defaults.i4pLightTheme)
      } else
      if (themename === 'Quanta') {
        this.setThemeImpl(this.$vuetify.theme.defaults.Quanta)
      } else
      if (themename === 'My Company') {
        this.setThemeImpl(this.$vuetify.theme.defaults.MyCompany)
      } else
      if (themename === 'From server config') {
        if ((this.$store.state.remoteConfig.theme) && (this.$store.state.remoteConfig.theme)) {
          const dynamicTheme = createDynamicTheme(this.$store.state.remoteConfig.theme)
          this.setThemeImpl(dynamicTheme)
        } else {
          console.error('No theme definition in server config')
        }
      }
    },
    setThemeImpl(theme, commitToo = true) {
      // close menu
      const name = theme.name
      this.headerLogo = theme.headerLogo

      if (commitToo) {
        this.$store.commit('setCurrentTheme', theme)
      }
      const light = theme.colors
      // set themes
      Object.keys(light).forEach(i => {
        this.$vuetify.theme.themes.light[i] = light[i]
      })
      const customVars = ['baBannerColor', 'modalButtonColor']
      this.updateCustomCssVars(light, customVars)
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name
    }
  }
}
</script>
<style>
@import "./styles/main.css";
</style>
<style>
.base-table {
  border-radius: 8px;
  filter: drop-shadow(-2px 2px 4px rgba(0, 0, 0, 0.11));
  width: 100%;
}

.v-btn {
  text-transform: none !important;
  box-shadow: initial;
  border-radius: 7px;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
